import NotificationHelper from 'helpers/NotificationHelper';
import AuthHelper from '@youfy/shared/helpers/AuthHelper';

class ResponseHelper {
  static errorInterceptor(result, error_message = 'Ops! Ocorreu algum problema durante a sua requisição :(') {
    const response = result.status ? result : result.response || {};
    const status = response.status;

    switch (status) {
      case 200:
        break;

      case 401:
        AuthHelper.clearToken();
        break;

      case 409:
        NotificationHelper.duplicatedData();
        throw result;

      case 404:
        throw result;

      case 403:
        const response = result.response || {};
        const data = response.data || {};
        const error = data.error || {};

        if (error.code === 'no_company') {
          setTimeout(() => NotificationHelper.showErrorPage(error.code), 300);
        } else {
          NotificationHelper.snack(error_message, 0);
        }

        throw result;

      default:
        throw result;
    }

    return { status };
  }
}

export default ResponseHelper;
